export const APP_QUICK_LINK_PATHNAME = '/mobileAppQuickLink';
export const APP_QUICK_LINK_HREF = `https://hosting.engager.uk/sites/mobileAppQuickLink/continue/?srcDomain=${window.location.hostname}`;